import * as React from 'react'
import { SubscriptionWithBenefitOffer } from '@modules/offers/subscription-with-benefit/subscription-with-benefit-offer'
import { SubscriptionContractOffer } from '@modules/offers/subscription-contract'
import { CodesConversionOffer } from '@modules/offers/codes-conversion'
import { BookingOffers } from '@modules/booking-offers'
import { SubscriptionsOffer } from '@modules/offers/subscriptions'
import { useOfferAvailability } from '@modules/offers/use-offer-availability'
import { GastroCardAugust2025Offer } from '@modules/offers/gastro-card/august-2025'
import { GastroCardChristmasOffer } from '@modules/offers/gastro-card/christmas'
import { CompanyOfferContact } from '@modules/offers/company-offers-contact'
import { GastroCardBlackWeek20Offer } from '@modules/offers/gastro-card/black-week-2_0'
import { GastroCardFebruary2026Offer } from '@modules/offers/gastro-card/february-2026'
import { GastroCardPromo20272028Offer } from '@modules/offers/gastro-card/promo-2027-2028'

export const OffersSection = (): React.ReactNode => {
  const { isAvailable } = useOfferAvailability()

  const dynamicRowClassOffers = [SubscriptionsOffer, CodesConversionOffer, SubscriptionContractOffer] as (({
    rowClassName,
  }) => JSX.Element)[]

  return (
    <>
      <SubscriptionWithBenefitOffer />
      {isAvailable('gastro_card_promo_2027_2028') && <GastroCardPromo20272028Offer />}
      {isAvailable('gastro_card_promo_february_2026') && <GastroCardFebruary2026Offer />}
      {isAvailable('gastro_card_black_week_20') && <GastroCardBlackWeek20Offer />}
      {isAvailable('gastro_card_black_week_2025') && <GastroCardAugust2025Offer />}
      <CompanyOfferContact />
      {isAvailable('gastro_card_christmas_2024') && <GastroCardChristmasOffer />}
      {dynamicRowClassOffers.map((Offer, index) => (
        <Offer key={index} rowClassName={index % 2 !== 0 ? '' : 'flex-row-reverse'} />
      ))}

      <BookingOffers />
    </>
  )
}
